<template>
  <img v-if="this.params.value && !this.params.data.hideLink" :src="src" />
</template>

<script>
export default {
  beforeMount() {
    this.src = `${process.env.BASE_URL}api/dashboard/location-image/${this.params.value}`
  }
}
</script>

<style scoped>
img {
  height: 80px;
  width: 100%;
  object-fit: cover;
  margin: 1rem 0;
}
</style>